import React, { useState, useEffect } from "react";
import axios from "axios";
import DailyForecast from "./DailyForecast";

export default function Forecast(props) {
  let [ready, setReady] = useState(false);
  let [forecastData, setForecast] = useState(null);

  useEffect(() => {
    setReady(false);
  }, [props.city]);

  function handleResponse(response) {
    setReady(true);
    setForecast(response.data.daily);
  }

  if (ready) {
    return (
      <div>
        <div class="future-weather">
          <div class="row">
            <div class="col border border-3 border-secondary-subtle">
              <DailyForecast data={forecastData[1]} />
            </div>
            <div className="col border border-3 border-secondary-subtle">
              <DailyForecast data={forecastData[2]} />
            </div>
            <div className="col border border-3 border-secondary-subtle">
              <DailyForecast data={forecastData[3]} />
            </div>
            <div className="col border border-3 border-secondary-subtle">
              <DailyForecast data={forecastData[4]} />
            </div>
            <div className="col border border-3 border-secondary-subtle">
              <DailyForecast data={forecastData[5]} />
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    const apiKey = "7tc34ea233a0fd494dc646afo0f7bac1";
    let units = "metric";
    let apiUrl = `https://api.shecodes.io/weather/v1/forecast?query=${props.city}&key=${apiKey}&units=${units}`;

    axios.get(apiUrl).then(handleResponse);
    return "Loading...";
  }
}
